export class AnnouncementType {
    public static readonly SellerNoVerifiedPaymentMethod = 'seller-no-verified-payment-method';
    public static readonly SellerKillSwitchIsOn = 'seller-killswitch-is-on';
}
